export const DisputeCmStatus = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  UNDER_REVIEW: 'under_review',
  WON: 'won',
  LOST: 'lost',
  CLOSED: 'closed',
  REFUNDED: 'refunded',
  ACCEPTED: 'accepted',
  UNKNOWN: 'unknown',
  UNFIGHTABLE: 'unfightable',
} as const;

export type DisputeCmStatus = typeof DisputeCmStatus[keyof typeof DisputeCmStatus];
